// Hash routes (no router dependency): #/ the board, #/patients/<id> one patient, #/help, #/demo.

import { useEffect, useState } from 'react';

export type Route =
  | { page: 'board' }
  | { page: 'patient'; encounterId: string }
  | { page: 'help' }
  | { page: 'demo' };

export function parseRoute(hash: string): Route {
  const path = hash.replace(/^#/, '');
  const patient = /^\/patients\/([0-9a-f-]{36})$/.exec(path);
  if (patient?.[1] !== undefined) return { page: 'patient', encounterId: patient[1] };
  if (path === '/help') return { page: 'help' };
  if (path === '/demo') return { page: 'demo' };
  return { page: 'board' };
}

export function href(route: Route): string {
  switch (route.page) {
    case 'patient':
      return `#/patients/${route.encounterId}`;
    case 'help':
      return '#/help';
    case 'demo':
      return '#/demo';
    case 'board':
      return '#/';
  }
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parseRoute(window.location.hash));
  useEffect(() => {
    const onChange = () => {
      setRoute(parseRoute(window.location.hash));
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return route;
}
